import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import BlockedCountry from '../../Models/BlockedCountry';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

class BlockedCountriesApi extends AbstractCRMApi {
    public endpoint: string = 'blocked_countries';

    public getAll(page: number = 1, config?: AxiosRequestConfig): Promise<GetPaginatedResponse<BlockedCountry>> {
        return this.get('', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetPaginatedResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, BlockedCountry);
        });
    }

    public store(item: Pick<BlockedCountry, 'iso_code'>) {
        return this.post('', item).then((response) => AbstractCRMApi.mapDataToModel(response.data, BlockedCountry));
    }
}

export default new BlockedCountriesApi();
